// extracted by mini-css-extract-plugin
module.exports = {"toggleFullScreen":"create-model_toggleFullScreen__3zs8U"};